import { CanMatchFn } from '@angular/router';

import { ParamsValidations, ParamValidationFunction } from '@/app/core/services/named-router';

export const routeParamsValidatorGuard: CanMatchFn = (route, segments) => {
  const pathParts = route.path?.split('/') || [];

  const customValidations: ParamsValidations = route.data?.['paramsValidations'] || {};

  const defaultValidation: ParamValidationFunction = (value) => !isNaN(Number(value));

  return pathParts.every((pathPart, index) => {
    if (pathPart.startsWith(':')) {
      const paramName = pathParts[index].substring(1);
      const paramValue = segments[index]?.path;

      if (paramValue) {
        const valid = customValidations[paramName] || defaultValidation;
        return valid(paramValue);
      }
    }

    return true;
  });
};
